import { render } from "./section-blog.vue?vue&type=template&id=a0aaad1c"
import script from "./section-blog.vue?vue&type=script&lang=js"
export * from "./section-blog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__